import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class ServicesService {
  api = environment.api;

  constructor(private http: HttpClient) {}

  listServices(filters = "") {
    return this.http.get(this.api + `/valor-servico${filters}`);
  }

  getService(id) {
    return this.http.get(this.api + `/valor-servico/${id}`);
  }

  addService(raw) {
    return this.http.post(this.api + `/valor-servico`, raw);
  }

  editService(raw) {
    console.log('Editar valor servico :', raw)
    return this.http.put(this.api + `/valor-servico`, raw);
  }

  deleteService(raw) {
    return this.http.delete(this.api + `/valor-servico/${raw.cdProduto}/${raw.cdFornecedor}/${raw.cdArea}`);
  }
}
